import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useActiveViewId } from '../../hooks/viewTabs';
import { useSearchResultsOfView } from '../../hooks/tasksSearchResults';
import { jsx as _jsx } from "react/jsx-runtime";
export function HeaderRecordCount() {
  const activeViewId = useActiveViewId();
  const searchResultsOfView = useSearchResultsOfView(activeViewId);
  const activeTabTotal = searchResultsOfView.loading ? undefined : searchResultsOfView.total;
  // Render a non-breaking space if we don't have a count to avoid page jumping
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    typography: "heading-25",
    whiteSpace: "nowrap",
    children: activeTabTotal === undefined ? /*#__PURE__*/_jsx("span", {
      children: "\xA0"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crm-tasks-ui.pageTitles.tasksCount",
      options: {
        count: activeTabTotal
      }
    })
  });
}